import { hasValue } from 'src/shared/utils/common';

import { FormStore } from '../entities/form.entity';
import { RigOperationSection } from '../entities/rig-operations/rig-operation-section.entity';
import { RigOperationStage } from '../entities/rig-operations/rig-operation-stage.entity';

import { FormPlugin } from './abstract-form-plugin.entity';

export class GeoLoadChangesDrillingDuration extends FormPlugin {
  connect(form: FormStore): VoidFunction {
    const geoLoadValuesChangingDisposer = form.eventBus.subscribe(
      'changeGeoLoadFieldValue',
      ({ fieldId, oldValue, geoLoadRigOperation, geoLoadStage, geoLoadSection }) => {
        if (
          fieldId !== 'coreSamplingDayAmount' &&
          fieldId !== 'daysAmountOfDataInterpretationOperation' &&
          fieldId !== 'testingFormationWorkDayAmount'
        ) {
          return;
        }

        const { rigOperationsService } = form;

        if (!geoLoadRigOperation) {
          return;
        }

        const rigOperation = rigOperationsService.rigOperationsMap.get(geoLoadRigOperation.rigOperationEntityId);

        if (!rigOperation) {
          console.error('cannot find corresponding rigOperation', geoLoadRigOperation);
          return;
        }

        if (
          !geoLoadStage &&
          rigOperation.stages.find((s) => rigOperationsService.isDrillingStage(s.wellLifeCycleStageId))
        ) {
          console.error(
            'geoLoadStage is not presented, but rigOperation contains drilling stage',
            rigOperation,
            geoLoadRigOperation,
          );
          return;
        }

        if (!geoLoadStage) {
          return;
        }

        const geoLoadSource = (geoLoadSection || geoLoadStage).geologicalLoad;
        const stage = rigOperation.stagesMap.get(geoLoadStage.stageEntityId);

        if (!stage) {
          console.error('cannot find corresponding stage', geoLoadStage.stageEntityId);
          return;
        }

        const section = geoLoadSection?.sectionEntityId
          ? stage.sectionsMap.get(geoLoadSection.sectionEntityId)
          : undefined;

        if (geoLoadSection && !section) {
          console.error('cannot find coresponding section', geoLoadSection.sectionEntityId);
          return;
        }

        const target: RigOperationStage | RigOperationSection | null = section ?? stage;

        if (!target) {
          return;
        }

        const newGeoLoadDaysSum = geoLoadSource.daysSumm;

        const oldGeoLoadDaysSum = (() => {
          const newAndOldValueDiff = (() => {
            if (!hasValue(geoLoadSource[fieldId]) && (!hasValue(oldValue) || typeof oldValue !== 'number')) {
              return null;
            }

            return (geoLoadSource[fieldId] ?? 0) - (typeof oldValue === 'number' ? oldValue : 0);
          })();

          return (newGeoLoadDaysSum ?? 0) - (newAndOldValueDiff ?? 0);
        })();

        const newAndOldGeoLoadDaysSummDiff = (() => {
          if (!hasValue(newGeoLoadDaysSum) && !hasValue(oldGeoLoadDaysSum)) {
            return null;
          }

          return (newGeoLoadDaysSum ?? 0) - (oldGeoLoadDaysSum ?? 0);
        })();

        const totalTargetDuration = (() => {
          if (!hasValue(target.duration) && !hasValue(newAndOldGeoLoadDaysSummDiff)) {
            return null;
          }

          return (target.duration ?? 0) + (newAndOldGeoLoadDaysSummDiff ?? 0);
        })();

        rigOperationsService.onValueChange('duration', totalTargetDuration, { rigOperation, stage, section });
      },
    );

    return geoLoadValuesChangingDisposer;
  }
}
